import { TAddress, TApplicationState } from '../models/application-state';
import { Option } from 'fp-ts/lib/Option';

export const getAdvisorDetails = (appState: TApplicationState) => {
	return {
		advisorPhoto: appState.advisorPhoto.getOrElse(''),
		advisorLogo: appState.advisorLogo.getOrElse(''),
		proposalLogo: appState.advisorPhoto.getOrElse(''),
		address: appState.address.fold('', add => parseAddress(add)),
		company: appState.companyName.getOrElse(''),
		isLogoPrefered: appState.isLogoPreferred.getOrElse(false),
		wordMark: appState.wordMark.getOrElse(''),
		phoneNumber: appState.phoneNumber.getOrElse(''),
		advisorName: appState.agentName.getOrElse(''),
	};
};

// export const parseAddress = (address: TAddress): string => {
// 	const addressArray = [];
// 	return `${address.line1.getOrElse('')}, ${address.line2.getOrElse('')}, ${address.line1.getOrElse(
// 		'',
// 	)}, ${address.line3.getOrElse('')}, ${address.city.getOrElse('')} ${address.postalCode.getOrElse('')}`;
// };

export const parseAddress = (address: TAddress): string => {
	const addressArray = [];
	return `${address.line1.getOrElse('')}, ${address.line2.getOrElse('') && `${address.line2.getOrElse('')}, `}${address.line3.getOrElse('') && `${address.line3.getOrElse('')}, `}${address.city.getOrElse('')} ${address.postalCode.getOrElse('')}`;
};

export const getLogoPath = (advisorLogo: Option<string>) => 
	 advisorLogo.fold("", logo => {
		const path = logo.split("path=");
		if(path[1]) {
			//console.log('path[1] :>> ', path[1]);
			return encodeURI(`/api/das/v1/Resources/downloadlogo?path=${path[1]}`);
		} else {
			return "";
		}
	});
